import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import { setInvFetchter, setSurveyFetchter } from "../Filter/actions";
import {
  addActionFailure,
  //
  addActionSuccess,
  addItemFailure,
  //
  addItemSuccess,
  addOutcomeFailure,
  //
  addOutcomeSuccess,
  addSurveyFailure,
  addSurveySuccess,
  deleteActionFailure,
  //
  deleteActionSuccess,
  deletePlanFailure,
  //
  deletePlanSuccess,
  //
  deleteSurveyFailure,
  deleteSurveySuccess,
  editActionFailure,
  //
  editActionSuccess,
  editItemFailure,
  //
  editItemSuccess,
  editOutcomeFailure,
  //
  editOutcomeSuccess,
  //
  editSurveyFailure,
  editSurveySuccess,
  exportSurveyFailure,
  exportSurveySuccess,
  fetchAnalyticsFailure,
  fetchAnalyticsSuccess,
  //
  fetchInvitees as fetchInviteesAction,
  fetchInviteesFailure,
  fetchInviteesSuccess,
  fetchResponsesFailure,
  //
  fetchResponsesSuccess,
  fetchSurveysFailure,
  //
  fetchSurveysSuccess,
  fetchTemplatesFailure,
  fetchTemplatesSuccess,
  generateQRFailure,
  //
  generateQRSuccess,
  //
  getActions,
  getActionsFailure,
  getActionsSuccess,
  getDashboardFailure,
  //
  getDashboardSuccess,
  getFindingReportFailure,
  getFindingReportSuccess,
  getHeadlinesFailure,
  //
  getHeadlinesSuccess,
  //
  getJsonFailure,
  getJsonSuccess,
  getOverviewFailure,
  //
  getOverviewSuccess,
  getPlanFailure,
  getPlanSuccess,
  //
  getViewData,
  getViewDataFailure,
  getViewDataSuccess,
  inviteFailure,
  //
  inviteSuccess,
  printPlanFailure,
  //
  printPlanSuccess,
  searchSurveyFailure,
  //
  searchSurveySuccess,
  toggleActionModal,
  toggleItemModal,
  toggleOutcomeModal,
  //
  updateJson,
  updateSummaryFailure,
  updateSummarySuccess,
  //
  generateJsonSuccess,
  generateJsonFailure,
  //
  getTemplatesSuccess,
  getTemplatesFailure,
  //
  getPredictionReport as getPredictionReportAction,
  getPredictionReportSuccess,
  getPredictionReportFailure,
  //
  getAiReportSuccess,
  getAiReportFailure,
  //
  getResponseSuccess,
  getResponseFailure,
  //
  fetchSurveyComparisonsSuccess,
  fetchSurveyComparisonsFailure,
  fetchCompareCandidatesSuccess,
  fetchCompareCandidatesFailure,
  createSurveyCompareSuccess,
  createSurveyCompareFailure,
  saveSurveyCompareSuccess,
  saveSurveyCompareFailure,
  deleteSurveyCompareSuccess,
  deleteSurveyCompareFailure,
  fetchSurveyCompareSuccess,
  fetchSurveyCompareFailure,
  regenerateSurveyCompareSuccess,
  regenerateSurveyCompareFailure,
  createSurveyImportSuccess,
  createSurveyImportFailure,
  fetchSurveyImportSuccess,
  fetchSurveyImportFailure,
  analyzeSurveyAiInviteSuccess,
  analyzeSurveyAiInviteFailure,
  mapSurveyAiInviteSuccess,
  mapSurveyAiInviteFailure,
} from "./actions";
import {
  ADD_ACTION,
  ADD_ITEM,
  ADD_OUTCOME,
  ADD_SURVEY,
  DELETE_ACTION,
  DELETE_PLAN,
  DELETE_SURVEY,
  EDIT_ACTION,
  EDIT_ITEM,
  EDIT_OUTCOME,
  EDIT_SURVEY,
  FETCH_INVITEES,
  FETCH_RESPONSES,
  FETCH_SURVEYS,
  GENERATE_QR,
  GET_ACTIONS,
  GET_DASHBOAD,
  GET_HEADLINES,
  GET_JSON,
  GET_OVERVIEW,
  GET_PLAN,
  GET_VIEW_DATA,
  INVITE,
  PRINT_PLAN,
  SEARCH_SURVEY,
  EXPORT_SURVEY,
  FETCH_TEMPLATES,
  GET_FINDING_REPORT,
  FETCH_ANALYTICS,
  UPDATE_SUMMARY,
  GENERATE_JSON,
  GET_TEMPLATES,
  GET_PREDICTION_REPORT,
  GET_AI_REPORT,
  GET_RESPONSE,
  FETCH_SURVEY_COMPARISONS,
  FETCH_COMPARE_CANDIDATES,
  CREATE_SURVEY_COMPARE,
  SAVE_SURVEY_COMPARE,
  DELETE_SURVEY_COMPARE,
  FETCH_SURVEY_COMPARE,
  CREATE_SURVEY_IMPORT,
  FETCH_SURVEY_IMPORT,
  REGENERATE_SURVEY_COMPARE,
  ANALYZE_SURVEY_AI_INVITE,
  MAP_SURVEY_AI_INVITE,
} from "./constants";

export function* fetchSurveys({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/survey-list?${query}`);
    yield put(fetchSurveysSuccess(data));
    yield put(setSurveyFetchter(true));
  } catch (e) {
    yield put(fetchSurveysFailure());
    yield put(setSurveyFetchter(true));
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching!"));
  }
}

export function* getViewDataSaga({ payload, onGetSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/survey/${payload}`);
    yield put(getViewDataSuccess(data));
    typeof onGetSuccess === "function" && onGetSuccess(data);
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addSurveySaga({ payload, history }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { formData, type } = payload;
  try {
    const data = yield call(api(token).post, `/api/survey/add`, formData);
    if (data) {
      yield put(successAlert("Survey added successfully!"));
      yield put(addSurveySuccess());
      history &&
        history.push(`/d/engage/${type}?location_id=${formData.location_id}`);
    }
  } catch (e) {
    yield put(addSurveyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editSurveySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/survey/edit/${payload.id}`,
      payload,
    );
    if (data) {
      yield put(getViewData(payload.id));
      yield put(getPredictionReportAction(payload.id));
      yield put(successAlert("Survey updated successfully!"));
      yield put(editSurveySuccess());
    }
  } catch (e) {
    yield put(editSurveyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteSurveySaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/survey/${payload?.id}`);
    if (data) {
      yield put(successAlert("Survey deleted successfully!"));
      yield put(deleteSurveySuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteSurveyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* generateQRSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token, null, false, true).post,
      `/api/survey-poster-pdf/${payload.id}`,
      payload?.data,
    );
    if (data) {
      typeof onSuccess === "function" && onSuccess(data);
      yield put(generateQRSuccess(data));
    }
  } catch (e) {
    yield put(generateQRFailure());
  }
}

export function* inviteSaga({ payload, onInvite }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/survey-invite`, payload);
    if (data) {
      yield put(successAlert("Invite scheduled successfully!"));
      yield put(inviteSuccess());
      yield put(
        fetchInviteesAction({
          data: {
            page: 1,
            limit: 10,
            survey_id: payload.survey_id,
          },
        }),
      );
      typeof onInvite === "function" && onInvite();
    }
  } catch (e) {
    yield put(inviteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchInviteesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-invite-list?${query}`,
    );
    yield put(fetchInviteesSuccess(data));
    yield put(setInvFetchter(true));
  } catch (e) {
    yield put(fetchInviteesFailure());
    yield put(setInvFetchter(true));
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching!"));
  }
}

export function* fetchResponsesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-response-list?${query}`,
    );
    yield put(fetchResponsesSuccess(data));
  } catch (e) {
    yield put(fetchResponsesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching!"));
  }
}

export function* getDashboardSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-dashboard?${query}`,
    );
    yield put(getDashboardSuccess(data));
  } catch (e) {
    yield put(getDashboardFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching!"));
  }
}

export function* getOverviewSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const tempList = yield select((state) => state?.SurveyReducer?.overviewList);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-question-overview?${query}`,
    );

    yield put(
      getOverviewSuccess({
        raw: data,
        list: data?.data?.length > 0 ? [...tempList, ...data.data] : [],
      }),
    );
  } catch (e) {
    yield put(getOverviewFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching!"));
  }
}

export function* getJsonSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const location = yield select(
    (state) => state?.SlickCareProfilesReducer?.activeLocation,
  );
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-json-question?${query}`,
    );
    let tempData = JSON.parse(JSON.stringify(data));
    tempData = tempData.map((ele, index) => {
      return {
        ...ele,
        question: ele?.question?.replaceAll("{location_name}", location?.title),
        sequence: index + 1,
      };
    });
    yield put(getJsonSuccess(data));
    yield put(updateJson(tempData));
  } catch (e) {
    yield put(getJsonFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching!"));
  }
}

export function* getHeadlinesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-question-headlines?${query}`,
    );
    yield put(getHeadlinesSuccess(data));
  } catch (e) {
    yield put(getHeadlinesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching!"));
  }
}

export function* searchSurveySaga({ payload, onSearchSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/search-survey?${query}`);
    yield put(searchSurveySuccess(data));
    typeof onSearchSuccess === "function" && onSearchSuccess(data);
  } catch (e) {
    yield put(searchSurveyFailure());
  }
}

export function* getActionsSaga({ payload, onAddSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-action-plan-list?${query}`,
    );
    yield put(getActionsSuccess(data));
    typeof onAddSuccess === "function" && onAddSuccess(data);
  } catch (e) {
    yield put(getActionsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching!"));
  }
}

export function* addActionSaga({ payload, onAddSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/survey-action-plan/add`,
      payload,
    );
    if (data) {
      yield put(successAlert("Action Plan added successfully!"));
      yield put(addActionSuccess());
      yield put(toggleActionModal({ open: false }));
      typeof onAddSuccess === "function" && onAddSuccess(data);
    }
  } catch (e) {
    yield put(addActionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editActionSaga({ payload, onEditSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/survey-action-plan/edit/${payload.id}`,
      payload,
    );
    if (data) {
      yield put(successAlert("Action plan updated successfully!"));
      yield put(editActionSuccess());
      typeof onEditSuccess === "function" && onEditSuccess();
    }
  } catch (e) {
    yield put(editActionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteActionSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).delete,
      `/api/survey-action-plan/${payload?.id}`,
    );
    if (data) {
      yield put(successAlert("Action plan deleted successfully!"));
      yield put(deleteActionSuccess());
      yield put(
        getActions({
          survey_id: payload.survey_id,
        }),
      );
    }
  } catch (e) {
    yield put(deleteActionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* addItemSaga({ payload, onItemAdd }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/survey-action-plan-item/add`,
      payload,
    );
    if (data) {
      yield put(successAlert("Action added successfully!"));
      yield put(addItemSuccess());
      yield put(toggleItemModal({ open: false }));
      typeof onItemAdd === "function" && onItemAdd();
    }
  } catch (e) {
    yield put(addItemFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* addOutcomeSaga({ payload, onAddOutcome }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/survey-item-outcome/add`,
      payload?.data,
    );
    if (data) {
      yield put(successAlert("Outcome added successfully!"));
      yield put(addOutcomeSuccess());
      yield put(toggleOutcomeModal({ open: false }));
      typeof onAddOutcome === "function" && onAddOutcome();
    }
  } catch (e) {
    yield put(addOutcomeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editOutcomeSaga({ payload, onEditOutcome }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/survey-item-outcome/edit/${payload.id}`,
      payload?.data,
    );
    if (data) {
      yield put(successAlert("Outcome updated successfully!"));
      yield put(editOutcomeSuccess());
      yield put(toggleOutcomeModal({ open: false }));
      typeof onEditOutcome === "function" && onEditOutcome();
    }
  } catch (e) {
    yield put(editOutcomeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getPlanSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-action-plan/${payload}`,
    );
    yield put(getPlanSuccess(data));
  } catch (e) {
    yield put(getPlanFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* deletePlanSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).delete,
      payload?.type === "outcome"
        ? `/api/survey-item-outcome/${payload?.id}`
        : `/api/survey-action-plan-item/${payload?.id}`,
    );
    if (data) {
      yield put(successAlert(`Action ${payload.type} deleted successfully!`));
      yield put(deletePlanSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deletePlanFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editItemSaga({ payload, onItemEdit }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/survey-action-plan-item/edit/${payload.id}`,
      payload,
    );
    if (data) {
      yield put(successAlert("Item updated successfully!"));
      yield put(editItemSuccess());
      yield put(toggleItemModal({ open: false }));
      typeof onItemEdit === "function" && onItemEdit();
    }
  } catch (e) {
    yield put(editItemFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* printPlanSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token, null, false, true).get,
      `/api/survey-action-plan-document/${payload?.id}`,
    );
    if (data) {
      yield put(printPlanSuccess());
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${payload?.title} Action Plan.pdf`);
      document.body.appendChild(link);
      link.click();
    }
  } catch (e) {
    yield put(printPlanFailure());
    yield put(errorAlert(`Error while printing!`));
  }
}

export function* exportSurveySaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, filters } = payload;
  let query = filters ? QueryString.stringify(filters) : "";
  try {
    const data = yield call(
      api(token, null, false, true).get,
      `/api/survey-export/${id}?${query}`,
    );
    typeof onSuccess === "function" && onSuccess();
    if (data) {
      yield put(exportSurveySuccess({ isFetching: false }));
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Responses.csv`);
      document.body.appendChild(link);
      link.click();
    }
  } catch (e) {
    yield put(exportSurveyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while exporting report!"));
    else yield put(errorAlert("Error while exporting report!"));
  }
}

export function* fetchTemplatesSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, type } = payload;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/company-survey-list/${id}?type=${type}`,
    );
    yield put(fetchTemplatesSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchTemplatesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching!"));
  }
}

export function* getFindingReportSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-question-unrated-overview?${query}`,
    );
    yield put(getFindingReportSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getFindingReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching!"));
  }
}

export function* getAnalyticsSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-overview-analytics?${query}`,
    );
    yield put(fetchAnalyticsSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchAnalyticsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching!"));
  }
}

export function* updateSummarySaga({ payload, onUpdate }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/survey-report/edit/${payload.id}`,
      payload.content,
    );
    if (data) {
      yield put(successAlert(`${payload.title} summary updated successfully!`));
      yield put(updateSummarySuccess());
      typeof onUpdate === "function" && onUpdate(data);
    }
  } catch (e) {
    yield put(updateSummaryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* generateJsonSaga({ payload, onGenerate }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/survey/ai/generate`,
      payload,
    );
    let combinedQuestions = [...data?.questions];
    yield put(generateJsonSuccess(combinedQuestions));
    typeof onGenerate === "function" && onGenerate(combinedQuestions);
  } catch (e) {
    yield put(generateJsonFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getTemplatesSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-template?${query}`,
    );
    yield put(getTemplatesSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getTemplatesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getPredictionReportSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey/${payload}/refresh-ai-predictions`,
    );
    yield put(getPredictionReportSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getPredictionReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getAiReportSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, type } = payload;
  let apiPath = `survey-ai-report`;
  if (type === "residents") apiPath = `survey-customer-ai-report`;
  if (type === "pulse") apiPath = `survey-pulse-ai-report`;
  try {
    const { data } = yield call(api(token).get, `/api/${apiPath}/${id}`);
    yield put(getAiReportSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getAiReportFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getResponsesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-response/${payload}`,
    );
    yield put(getResponseSuccess(data));
  } catch (e) {
    yield put(getResponseFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchSurveyComparisonsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-comparisons?${query}`,
    );
    yield put(fetchSurveyComparisonsSuccess(data));
  } catch (e) {
    yield put(fetchSurveyComparisonsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching comparisons!"));
  }
}

export function* fetchCompareCandidatesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-compare-candidates?${query}`,
    );
    yield put(fetchCompareCandidatesSuccess(data));
  } catch (e) {
    yield put(fetchCompareCandidatesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching surveys!"));
  }
}

export function* createSurveyCompareSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/survey-compare`,
      payload,
    );
    yield put(createSurveyCompareSuccess(data));
    if (data?.existing) {
      yield put(successAlert("Opened existing comparison"));
    }
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(createSurveyCompareFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while generating comparison!"));
  }
}

export function* saveSurveyCompareSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/survey-compare/save`,
      payload,
    );
    yield put(saveSurveyCompareSuccess(data));
    yield put(successAlert("Comparison saved successfully!"));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(saveSurveyCompareFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while saving comparison!"));
  }
}

export function* deleteSurveyCompareSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).delete,
      `/api/survey-compare/${payload}`,
    );
    yield put(deleteSurveyCompareSuccess(data));
    yield put(successAlert("Comparison deleted successfully!"));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(deleteSurveyCompareFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while deleting comparison!"));
  }
}

export function* fetchSurveyCompareSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-compare/${payload}`,
    );
    yield put(fetchSurveyCompareSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchSurveyCompareFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while loading comparison!"));
  }
}

function aiReportPathForType(type) {
  if (type === "residents" || type === "customer") {
    return "survey-customer-ai-report";
  }
  if (type === "pulse") {
    return "survey-pulse-ai-report";
  }
  return "survey-ai-report";
}

export function* regenerateSurveyCompareSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const {
    id,
    survey_id_a: surveyIdA,
    survey_id_b: surveyIdB,
    type,
  } = payload || {};

  try {
    const apiPath = aiReportPathForType(type);
    // Refresh each survey AI report first so new responses feed the comparison.
    if (surveyIdA) {
      yield call(api(token).get, `/api/${apiPath}/${surveyIdA}`);
    }
    if (surveyIdB) {
      yield call(api(token).get, `/api/${apiPath}/${surveyIdB}`);
    }

    const { data } = yield call(
      api(token).post,
      `/api/survey-compare/${id}/regenerate`,
    );
    yield put(regenerateSurveyCompareSuccess(data));
    yield put(successAlert("Comparison regenerated with latest responses"));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(regenerateSurveyCompareFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while regenerating comparison!"));
  }
}

export function* createSurveyImportSaga({ payload, onSuccess, onFailure }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const formData = payload instanceof FormData ? payload : payload?.formData;
    const { data } = yield call(
      api(token).post,
      `/api/survey-import`,
      formData,
      { timeout: 300000 },
    );
    yield put(createSurveyImportSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(createSurveyImportFailure());
    typeof onFailure === "function" && onFailure(e);
  }
}

export function* fetchSurveyImportSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/survey-import/${payload}`,
    );
    yield put(fetchSurveyImportSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchSurveyImportFailure());
    // Keep polling on transient network errors; terminal states are handled in the modal.
  }
}

export function* fetchSurveysFlow() {
  yield takeEvery(FETCH_SURVEYS, fetchSurveys);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addSurveyFlow() {
  yield takeEvery(ADD_SURVEY, addSurveySaga);
}
export function* editSurveyFlow() {
  yield takeEvery(EDIT_SURVEY, editSurveySaga);
}
export function* deleteSurveyFlow() {
  yield takeEvery(DELETE_SURVEY, deleteSurveySaga);
}
export function* generateQRFlow() {
  yield takeEvery(GENERATE_QR, generateQRSaga);
}
export function* inviteFlow() {
  yield takeEvery(INVITE, inviteSaga);
}
export function* fetchInviteesFlow() {
  yield takeEvery(FETCH_INVITEES, fetchInviteesSaga);
}

export function* analyzeSurveyAiInviteSaga({ payload, onSuccess, onFailure }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/survey-invite-ai-import/analyze`,
      payload,
      { timeout: 60000 },
    );
    yield put(analyzeSurveyAiInviteSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(analyzeSurveyAiInviteFailure());
    typeof onFailure === "function" && onFailure(e);
  }
}

export function* mapSurveyAiInviteSaga({ payload, onSuccess, onFailure }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/survey-invite-ai-import/map`,
      payload,
    );
    yield put(mapSurveyAiInviteSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(mapSurveyAiInviteFailure());
    typeof onFailure === "function" && onFailure(e);
  }
}

export function* analyzeSurveyAiInviteFlow() {
  yield takeEvery(ANALYZE_SURVEY_AI_INVITE, analyzeSurveyAiInviteSaga);
}

export function* mapSurveyAiInviteFlow() {
  yield takeEvery(MAP_SURVEY_AI_INVITE, mapSurveyAiInviteSaga);
}
export function* fetchResponsesFlow() {
  yield takeEvery(FETCH_RESPONSES, fetchResponsesSaga);
}
export function* getDashboardFlow() {
  yield takeEvery(GET_DASHBOAD, getDashboardSaga);
}
export function* getOverviewFlow() {
  yield takeEvery(GET_OVERVIEW, getOverviewSaga);
}
export function* getJsonFlow() {
  yield takeEvery(GET_JSON, getJsonSaga);
}
export function* getHeadlinesFlow() {
  yield takeEvery(GET_HEADLINES, getHeadlinesSaga);
}
export function* searchSurveyFlow() {
  yield takeEvery(SEARCH_SURVEY, searchSurveySaga);
}
export function* getActionsFlow() {
  yield takeEvery(GET_ACTIONS, getActionsSaga);
}
export function* addActionFlow() {
  yield takeEvery(ADD_ACTION, addActionSaga);
}
export function* deleteActionFlow() {
  yield takeEvery(DELETE_ACTION, deleteActionSaga);
}
export function* addItemFlow() {
  yield takeEvery(ADD_ITEM, addItemSaga);
}
export function* addOutcomeFlow() {
  yield takeEvery(ADD_OUTCOME, addOutcomeSaga);
}
export function* editOutcomeFlow() {
  yield takeEvery(EDIT_OUTCOME, editOutcomeSaga);
}
export function* getPlanFlow() {
  yield takeEvery(GET_PLAN, getPlanSaga);
}
export function* deletePlanFlow() {
  yield takeEvery(DELETE_PLAN, deletePlanSaga);
}
export function* editItemFlow() {
  yield takeEvery(EDIT_ITEM, editItemSaga);
}
export function* editActionFlow() {
  yield takeEvery(EDIT_ACTION, editActionSaga);
}
export function* printPlanFlow() {
  yield takeEvery(PRINT_PLAN, printPlanSaga);
}
export function* exportSurveyFlow() {
  yield takeEvery(EXPORT_SURVEY, exportSurveySaga);
}
export function* fetchTemplatesFlow() {
  yield takeEvery(FETCH_TEMPLATES, fetchTemplatesSaga);
}
export function* getFindingReportFlow() {
  yield takeEvery(GET_FINDING_REPORT, getFindingReportSaga);
}
export function* getAnalyticsFlow() {
  yield takeEvery(FETCH_ANALYTICS, getAnalyticsSaga);
}
export function* updateSummaryFlow() {
  yield takeEvery(UPDATE_SUMMARY, updateSummarySaga);
}
export function* generateJsonFlow() {
  yield takeEvery(GENERATE_JSON, generateJsonSaga);
}
export function* getTemplatesFlow() {
  yield takeEvery(GET_TEMPLATES, getTemplatesSaga);
}
export function* getPredictionReportFlow() {
  yield takeEvery(GET_PREDICTION_REPORT, getPredictionReportSaga);
}
export function* getAiReportFlow() {
  yield takeEvery(GET_AI_REPORT, getAiReportSaga);
}
export function* getResponsesFlow() {
  yield takeEvery(GET_RESPONSE, getResponsesSaga);
}
export function* fetchSurveyComparisonsFlow() {
  yield takeEvery(FETCH_SURVEY_COMPARISONS, fetchSurveyComparisonsSaga);
}
export function* fetchCompareCandidatesFlow() {
  yield takeEvery(FETCH_COMPARE_CANDIDATES, fetchCompareCandidatesSaga);
}
export function* createSurveyCompareFlow() {
  yield takeEvery(CREATE_SURVEY_COMPARE, createSurveyCompareSaga);
}
export function* saveSurveyCompareFlow() {
  yield takeEvery(SAVE_SURVEY_COMPARE, saveSurveyCompareSaga);
}
export function* deleteSurveyCompareFlow() {
  yield takeEvery(DELETE_SURVEY_COMPARE, deleteSurveyCompareSaga);
}
export function* fetchSurveyCompareFlow() {
  yield takeEvery(FETCH_SURVEY_COMPARE, fetchSurveyCompareSaga);
}
export function* regenerateSurveyCompareFlow() {
  yield takeEvery(REGENERATE_SURVEY_COMPARE, regenerateSurveyCompareSaga);
}
export function* createSurveyImportFlow() {
  yield takeEvery(CREATE_SURVEY_IMPORT, createSurveyImportSaga);
}
export function* fetchSurveyImportFlow() {
  yield takeEvery(FETCH_SURVEY_IMPORT, fetchSurveyImportSaga);
}

export default function* SurveySaga() {
  yield all([
    fetchSurveysFlow(),
    getViewDataFlow(),
    addSurveyFlow(),
    editSurveyFlow(),
    deleteSurveyFlow(),
    generateQRFlow(),
    inviteFlow(),
    fetchInviteesFlow(),
    analyzeSurveyAiInviteFlow(),
    mapSurveyAiInviteFlow(),
    fetchResponsesFlow(),
    getDashboardFlow(),
    getOverviewFlow(),
    getJsonFlow(),
    getHeadlinesFlow(),
    searchSurveyFlow(),
    getActionsFlow(),
    addActionFlow(),
    editActionFlow(),
    deleteActionFlow(),
    addItemFlow(),
    addOutcomeFlow(),
    getPlanFlow(),
    editOutcomeFlow(),
    deletePlanFlow(),
    editItemFlow(),
    printPlanFlow(),
    exportSurveyFlow(),
    fetchTemplatesFlow(),
    getFindingReportFlow(),
    getAnalyticsFlow(),
    updateSummaryFlow(),
    generateJsonFlow(),
    getTemplatesFlow(),
    getPredictionReportFlow(),
    getAiReportFlow(),
    getResponsesFlow(),
    fetchSurveyComparisonsFlow(),
    fetchCompareCandidatesFlow(),
    createSurveyCompareFlow(),
    saveSurveyCompareFlow(),
    deleteSurveyCompareFlow(),
    fetchSurveyCompareFlow(),
    regenerateSurveyCompareFlow(),
    createSurveyImportFlow(),
    fetchSurveyImportFlow(),
  ]);
}
